import React, { useEffect } from 'react'
import Moudles from '../modules'
import { action_fetch_init_data } from '../../../../../store/actions/pages/simple-landing'

import { useSelector } from 'react-redux'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import Footer from '../../../layout/fragments/footer'
import { useStore } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { getCountryMessage } from '../../../../../api'
import { useQuery } from '../../../../hooks/common'
// import LuckStar from '../../../layout/fragments/luck-star'
import BlackCouponAlert from '../../../layout/fragments/black-coupon-alert'



const SimpleLandingPage = props => {

    useStyles(classes)
    const store = useStore()
    const pageSimpleLanding = useSelector((state) => state.pageSimpleLanding)
    const simpleData = pageSimpleLanding?.simpleData
    const location = useLocation()
    const testImage = 'https://s3.us-west-2.amazonaws.com/image.chic-fusion.com/chicme/20220801/lottery-pc-back.jpg'

    const query = useQuery();


    useEffect(async () => {
        if (window.__INITIAL_STATE__) {
            delete window.__INITIAL_STATE__
        } else {
            if (!simpleData) {
                const urlConfigs = await getCountryMessage('M1640').then(data => data.result)
                const currentConfig = urlConfigs?.[location.pathname]

                SimpleLandingPage.fetchData(store, null, { code: currentConfig?.code }).then(data => {
                    const pageData = data?.[0]
                    window.currentPage = 'landing'
                    window.pageContent = pageData?.refId
                    document.title = pageData?.title

                    if (window.GeekoSensors) {
                        window.GeekoSensors.Quick('autoTrackSinglePage', {
                            page_sort: 'landing',
                            page_title: '活动落地页',
                            page_content: pageData?.refId
                        })
                    }


                })
            }else{
                if (window.GeekoSensors) {
                    window.GeekoSensors.Quick('autoTrackSinglePage', {
                        page_sort: 'landing',
                        page_title: '活动落地页',
                        page_content: simpleData?.refId
                    })
                }
            }

            
        }
    }, [])

    useEffect(() =>{
        // console.log('query?.locationModule', query?.locationModule)
        if(query?.locationModule){
            // console.log('ocument.getElementById(query?.locationModule)', document.getElementById(query?.locationModule))
            document?.getElementById(query?.locationModule)?.scrollIntoView?.({
                behavior: 'smooth'
            })
        }
    },[])

    return <div style={{overflowX: 'hidden'}}>

        <div style={{
            backgroundImage: pageSimpleLanding?.simpleData?.theme?.backgroundImage ? `url(${pageSimpleLanding?.simpleData?.theme?.backgroundImage})` : undefined,
            // backgroundImage: `url(${testImage})`,
            backgroundColor: pageSimpleLanding?.simpleData?.theme?.backgroundColor,
            backgroundRepeat: 'repeat-y',
            backgroundSize: '100% 100%',
            backgroundPosition: 'top',
        }}>
            <Moudles data={pageSimpleLanding?.simpleData?.modules} sensors={
                {
                    title: pageSimpleLanding?.simpleData?.refId,
                }
            } />
        </div>

        {/* <LuckStar/> */}

        <BlackCouponAlert />

        <Footer />
    </div>
}

SimpleLandingPage.fetchData = async (store, params, search, headers) => {
    const code = search?.code
    const promises = [
        store.dispatch(action_fetch_init_data(code, headers)),
    ]
    const data = await Promise.all(promises)
    return data
}

export default SimpleLandingPage